import { EXAMPLE_PROMPTS_COPY } from './constants';
import styles from './ExamplePromptsPreview.module.css';
import type { ExamplePromptDraft } from './types';

interface ExamplePromptsPreviewProps {
  drafts: ExamplePromptDraft[];
}

export const ExamplePromptsPreview = ({ drafts }: ExamplePromptsPreviewProps) => {
  const titledDrafts = drafts
    .map(draft => ({ id: draft.id, title: draft.title.trim() }))
    .filter(draft => draft.title);

  const titledDraftsExist = titledDrafts.length > 0;
  if (!titledDraftsExist) return null;

  return (
    <figure className={styles.preview}>
      <figcaption>{EXAMPLE_PROMPTS_COPY.previewLabel}</figcaption>
      <p aria-hidden="true">{EXAMPLE_PROMPTS_COPY.previewComposerPlaceholder}</p>
      <ul>
        {titledDrafts.map(draft => (
          <li key={draft.id}>{draft.title}</li>
        ))}
      </ul>
    </figure>
  );
};
